// App Build Version - Update this on each deployment
// This constant is used to verify that users have loaded the latest bundle

export const APP_BUILD_VERSION = "2025.02.13.RAMS.v3";

// Expose to window for debugging and verification
if (typeof window !== 'undefined') {
  window.__APP_BUILD_VERSION__ = APP_BUILD_VERSION;
}

// Log version on load
console.log(`[VeriTrade] App Build Version: ${APP_BUILD_VERSION}`);
